import { ParsedUrlQuery } from "node:querystring";
import qs from "qs";
import querystring from "querystring";
import './stripe';
/**
 * Thanks https://gist.github.com/codeguy/6684588#gistcomment-3666173
 * @param args
 * @returns
 */
export const slugify = (...args: any) => {
  const value = args.join(" ");
  return value
    .normalize("NFD") // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, "") // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, "-"); // separator
};

export type GatsbyLocationType = {
  pathname: string;
  search: string;
  hash: string;
  href: string;
  origin: string;
  protocol: string;
  host: string;
  hostname: string;
  port: string;
  state: boolean | null;
  key: string;
};

export const getUrlQueryObject = (
  location: GatsbyLocationType | null
): ParsedUrlQuery => {
  if (!location) return {};
  const query = querystring.parse(location.search.replace("?", ""));
  console.log("utm", query);
  return query;
};

export const isBrowser = Boolean(typeof window !== "undefined");

export const isEmptyObject = (obj: Record<string, any>) =>
  !Boolean(Object.keys(obj).length);

export const localStorageSetItem = (
  key: string,
  value: string | Record<string, any>
): void => {
  isBrowser && window.localStorage.setItem(key, JSON.stringify(value));
};

export const localStorageGetItem = (key: string): string | boolean => {
  return isBrowser && (window?.localStorage!.getItem(key) as string);
};

export const setInitialLocation = (location: GatsbyLocationType): void => {
  if (!location) return;

  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  if (isEmptyObject(query)) return;

  const prevQuery = getInitalQuery();
  localStorageSetItem("initialQuery", { ...prevQuery, ...query });
};

export const getInitalQuery = () => {
  if (localStorage.initialQuery !== undefined) {
    // just resetting the initialQuery item is more reliable in removing the query from browser than just returning undefined
    // return undefined;
    localStorageSetItem("initialQuery", {});
  } else {
    return JSON.parse(localStorageGetItem("initialQuery") as string);
  }
};

export const mergeWithInitialQuery = (query: string): string => {
  return qs.stringify({
    ...getInitalQuery(),
    ...qs.parse(query, { ignoreQueryPrefix: true }),
  });
};

// rename fields so the match hs and cognito
export const formDataToHubspotProperties = (formData: any) => ({
  firstname: formData!.first_name,
  lastname: formData!.last_name,
  email: formData!.email,
  phone: formData!.work_phone,
  company: formData!.company,
});

/**
 * Return error message or String(error)
 * @param error 
 * @returns string
 */
export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message
  return String(error)
}